var map = {
	"./abstract01.webp": 2416,
	"./abstract010.webp": 2417,
	"./abstract02.webp": 2418,
	"./abstract03.webp": 2419,
	"./abstract05.webp": 2420,
	"./abstract06.webp": 2421,
	"./abstract07.webp": 2422,
	"./big_head_-1.webp": 2423,
	"./big_head_-10.webp": 2424,
	"./big_head_-2.webp": 2425,
	"./big_head_-3.webp": 2426,
	"./big_head_-5.webp": 2427,
	"./big_head_-6.webp": 2428,
	"./big_head_-7.webp": 2429,
	"./small_head_-1.webp": 2430,
	"./small_head_-10.webp": 2431,
	"./small_head_-2.webp": 2432,
	"./small_head_-3.webp": 2433,
	"./small_head_-5.webp": 2434,
	"./small_head_-6.webp": 2435,
	"./small_head_-7.webp": 2436,
	"./sponsor-banner-cn-m.webp": 2437,
	"./sponsor-banner-cn.webp": 2438,
	"./sponsor-banner-id-m.webp": 2439,
	"./sponsor-banner-id.webp": 2440,
	"./sponsor-banner-m.webp": 2441,
	"./sponsor-banner-ms-m.webp": 2442,
	"./sponsor-banner-ms.webp": 2443,
	"./sponsor-banner.webp": 2444,
	"./sponsor-bg-1-cn.webp": 2445,
	"./sponsor-bg-1-id.webp": 2446,
	"./sponsor-bg-1-ms.webp": 2447,
	"./sponsor-bg-1.webp": 2448,
	"./sponsor-bg-2-cn.webp": 2449,
	"./sponsor-bg-2-id.webp": 2450,
	"./sponsor-bg-2-ms.webp": 2451,
	"./sponsor-bg-2.webp": 2452,
	"./sponsor-bg-m-2-cn.webp": 2453,
	"./sponsor-bg-m-2-id.webp": 2454,
	"./sponsor-bg-m-2-ms.webp": 2455,
	"./sponsor-bg-m-2.webp": 2456,
	"./sponsor-video-one.mp4": 2457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2415;